import { Pipe, PipeTransform } from '@angular/core';
import { FileService } from 'src/app/services/file.service';

@Pipe({ name: 'authImage' })
export class AuthImagePipe implements PipeTransform {

  constructor(
    private fileService: FileService
  ) {}

  async transform(src: string) {
    return this.fileService.getSecure(src);
  }
}